import { observer } from "mobx-react-lite";

import { useStore } from "@/store";
import { twMerge } from "@/utils/twMerge";

import { Footer } from "./Footer";
import { Header } from "./Header";
import { StepAvatar } from "./steps/StepAvatar";
import { StepInvites } from "./steps/StepInvites";
import { StepPermalink } from "./steps/StepPermalink";
import { StepTitle } from "./steps/StepTitle";

/**
 * Shared create-team flow: header + step content + footer (on title step).
 * Used by CreateTeamDialog and by the /create-team page.
 */
export const CreateTeamFlow = observer(function CreateTeamFlow({
  className,
  contentClassName,
  withHeader = false,
}: {
  className?: string;
  contentClassName?: string;
  withHeader?: boolean;
}) {
  const { dialog } = useStore();
  const { createTeamDialog } = dialog;

  return (
    <div className={twMerge("flex flex-col w-full", className)}>
      {withHeader && <Header />}
      <div
        className={twMerge(
          "flex flex-col w-full max-w-[372px] mx-auto my-[80px] px-4",
          "sm:my-[40px]",
          contentClassName,
        )}
      >
        {createTeamDialog.step === "title" && <StepTitle />}
        {createTeamDialog.step === "permalink" && <StepPermalink />}
        {createTeamDialog.step === "avatar" && <StepAvatar />}
        {createTeamDialog.step === "invites" && <StepInvites />}
      </div>
      {createTeamDialog.step === "title" && <Footer />}
    </div>
  );
});
